var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrontendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_141_175)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.975,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9688 4.03125C31.9688 11.9896 31.9688 19.9479 31.9688 27.9062C31.6132 29.001 30.8632 29.6364 29.7188 29.8125C20.5521 29.8542 11.3854 29.8542 2.21875 29.8125C1.07432 29.6364 0.324324 29.001 -0.03125 27.9062C-0.03125 19.9479 -0.03125 11.9896 -0.03125 4.03125C0.324324 2.93648 1.07432 2.30107 2.21875 2.125C11.3854 2.08333 20.5521 2.08333 29.7188 2.125C30.8632 2.30107 31.6132 2.93648 31.9688 4.03125ZM2.40625 4.28125C11.4479 4.27083 20.4896 4.28125 29.5312 4.3125C29.6207 4.34158 29.6936 4.39366 29.75 4.46875C29.7812 5.4477 29.7917 6.42688 29.7812 7.40625C20.5729 7.40625 11.3646 7.40625 2.15625 7.40625C2.14584 6.42688 2.15626 5.4477 2.1875 4.46875C2.25907 4.39773 2.33198 4.33523 2.40625 4.28125ZM2.15625 9.59375C11.3646 9.59375 20.5729 9.59375 29.7812 9.59375C29.7917 15.5521 29.7812 21.5104 29.75 27.4688C29.6936 27.5438 29.6207 27.5959 29.5312 27.625C20.4896 27.6667 11.4479 27.6667 2.40625 27.625C2.31682 27.5959 2.24391 27.5438 2.1875 27.4688C2.15625 21.5104 2.14583 15.5521 2.15625 9.59375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.914,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.21874 5.03126C5.09385 5.02087 5.41676 5.43754 5.18749 6.28126C4.66508 6.85401 4.16508 6.83319 3.68749 6.21876C3.52192 5.67457 3.699 5.27874 4.21874 5.03126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.92,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.78125 5.03128C7.65775 5.02211 7.98062 5.43878 7.75 6.28128C7.20062 6.86321 6.70062 6.82159 6.25 6.15628C6.13376 5.63849 6.31087 5.26349 6.78125 5.03128Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.917,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.34376 5.03125C10.367 5.07788 10.6483 5.55705 10.1875 6.46875C9.63007 6.8295 9.1717 6.72531 8.81251 6.15625C8.70626 5.63982 8.88332 5.26482 9.34376 5.03125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.961,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0937 12.2188C20.2044 12.3359 20.569 12.9192 20.1875 13.9688C18.125 17.5312 16.0625 21.0938 14 24.6562C13.3369 25.1821 12.7327 25.1196 12.1875 24.4688C12.1063 24.2899 12.0542 24.1024 12.0312 23.9062C12.0931 23.5949 12.2077 23.3033 12.375 23.0312C14.375 19.5729 16.375 16.1146 18.375 12.6562C18.5766 12.4362 18.8161 12.2904 19.0937 12.2188Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.961,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.28125 13.4063C10.3411 13.3719 10.7891 13.8719 10.625 14.9063C10.5833 14.9896 10.5417 15.0729 10.5 15.1563C9.35332 16.2926 8.21788 17.4384 7.09375 18.5938C8.21788 19.7491 9.35332 20.8949 10.5 22.0313C10.8393 22.6596 10.7246 23.1908 10.1563 23.625C9.72719 23.8481 9.3105 23.8273 8.90625 23.5625C7.47919 22.1354 6.05209 20.7083 4.625 19.2813C4.33712 18.8188 4.33712 18.3604 4.625 17.9063C6.07292 16.4583 7.52082 15.0104 8.96875 13.5625C9.08219 13.5152 9.18632 13.4631 9.28125 13.4063Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.961,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0312 13.4063C22.3589 13.3765 22.6714 13.4285 22.9688 13.5625C24.4167 15.0105 25.8646 16.4583 27.3125 17.9063C27.6004 18.3605 27.6004 18.8188 27.3125 19.2813C25.8854 20.7083 24.4583 22.1355 23.0312 23.5625C22.0587 23.9929 21.4546 23.6908 21.2188 22.6563C21.2481 22.4329 21.321 22.2245 21.4375 22.0313C22.5842 20.895 23.7196 19.7491 24.8438 18.5938C23.7196 17.4384 22.5842 16.2926 21.4375 15.1563C21.0599 14.374 21.2579 13.7907 22.0312 13.4063Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_141_175"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontendIcon);
export default __webpack_public_path__ + "static/media/frontend-icon.5a80fbed3c216c439ae62e3ce3908478.svg";
export { ForwardRef as ReactComponent };